import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getDatabase } from "firebase/database";



// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
//   databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
// };


const firebaseConfig = {
  apiKey: "AIzaSyC4CUxNePAtFm8NX2N9PB28psnLKBasJbc",
  authDomain: "flintt-f9792.firebaseapp.com",
  projectId: "flintt-f9792",
  storageBucket: "flintt-f9792.firebasestorage.app",
  messagingSenderId: "961495691353",
  appId: "1:961495691353:web:5148e67d04f317ee5bc148",
  databaseURL: "https://flintt-f9792-default-rtdb.europe-west1.firebasedatabase.app/",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const rtdb = getDatabase(app);

// enableIndexedDbPersistence(db).catch((err) => {
//   if (err.code === "failed-precondition") {
//     // Multiple tabs open, persistence can only be enabled
//     // in one tab at a time.
//     // ...
//   } else if (err.code === "unimplemented") {
//     // The current browser does not support all of the
//     // features required to enable persistence
//     // ...
//   }

// // import { initializeApp } from "firebase/app";
// // import { getAuth, GoogleAuthProvider } from "firebase/auth";
// // import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
// // import { getStorage } from "firebase/storage";
// // import { getFunctions } from "firebase/functions";

// // const firebaseConfig = {
// //   apiKey: "AIzaSy********************snLKBasJbc",
// //   authDomain: "fli****************************************om",
// //   projectId: "fl*******************************92",
// //   storageBucket: "flintt******************************rage.app",
// //   messagingSenderId: "9614******1353",
// //   appId: "1:96149569135******************************7ee5bc148",
// //   databaseURL: "https://f********************************tabase.app/",
// // };

// // export const app = initializeApp(firebaseConfig);
// // export const auth = getAuth(app);
// // export const googleProvider = new GoogleAuthProvider();
// // export const db = getFirestore(app);
// // export const storage = getStorage(app);
// // export const functions = getFunctions(app);

// // enableIndexedDbPersistence(db).catch((err) => {
// //   if (err.code === "failed-precondition") {
// //     // Multiple tabs open, persistence can only be enabled
// //     // in one tab at a time.
// //     // ...
// //   } else if (err.code === "unimplemented") {
// //     // The current browser does not support all of the
// //     // features required to enable persistence
// //     // ...
// //   }
// });
